// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__25uXs","inputWrap":"CustomTip_inputWrap__2Fgbl"};